import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import useAuth from "./hooks/use_auth";
import Navbar from "./common_components/navbar/Navbar";
import Footer from "./common_components/footer/Footer";
import HomePage from "./pages/home/HomePage";
import AllEvents from "./pages/home/AllEvents";
import EventsFiltersPage from "./pages/events-filters/EventsFiltersPage";
import Login from "./pages/login/login";
import Privacypolicy from "./pages/privacy_policy/Privacypolicy";
import Termsandcondition from "./pages/terms_and_conditions/Termsandcondition";
import ProtectedRoute from "./common_components/ProtectedRoute";
import EventDetails from "./pages/event_details/EventDetails";
import SelectTickets from "./pages/select_ticket/SelectTickets";
import Checkout from "./pages/checkout_ticket/checkout_ticket";
import sharefeature from "./pages/sharefeature/ShareButton";
import MyProfile from "./pages/MyProfile/MyProfile";
import MyBookings from "./pages/MyBookings/MyBookings";
import Contact_us from "./pages/Contact_us/Contact_Us";
import TempRazorpayButton from "./common_components/TempRazorpayButton";
import TicketPage from "./pages/ticket/TicketPage";

import SetupAccount from "./pages/setup-account/SetupAccount";

import { ApiService } from "./services/api_service";

// Component to conditionally render Navbar
const AppContent = ({ userData, user }) => {
  const location = useLocation();

  // Don't show Navbar on login page
  const hideNavbarPaths = ['/login'];
  const shouldShowNavbar = !hideNavbarPaths.includes(location.pathname);

  return (
    <>
      {shouldShowNavbar && <Navbar username={userData?.name} />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/all-events" element={<AllEvents />} />
        <Route path="/events-filters" element={<EventsFiltersPage />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/event-detail" element={<EventDetails />} /> */}
        <Route path="/events/:eventId" element={<EventDetails />} />
        <Route path="/select-tickets/:eventId" element={<SelectTickets />} />
        <Route path="/checkout-tickets" element={<Checkout />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/Terms & Conditions" element={<Termsandcondition />} />
        <Route path="/Contact_Us" element={<Contact_us />} />
        <Route path="/profile" element={<MyProfile />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/ticket/:bookingId" element={<TicketPage />} />
        <Route path="/setup-account" element={<SetupAccount />} />
        {/* Below Two Routues (/protected and /temp-checkout) are just for testing purpose */}
        <Route
          path="/protected"
          element={user ? <ProtectedRoute /> : <Navigate to="/login" />}
        />
        <Route path="/temp-checkout" element={<TempRazorpayButton />} />
      </Routes>
      {shouldShowNavbar && <Footer />}
    </>
  );
};

function App() {
  const user = useAuth();

  const uid = user ? user.uid : null;

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!uid) {
      console.warn("No user ID provided");
      return;
    }

    const fetchUser = async () => {
      setLoading(true);
      try {
        const response = await ApiService.getSingleUser(uid);
        const userData = response.data || response;

        if (userData) {
          setUserData(userData);
        } else {
          console.warn("No such user!");
          setUserData(null);
        }
      } catch (err) {
        setError(null);
        console.warn("User fetch failed (possibly new user):", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [uid]);

  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center text-white">Loading...</div>;
  // if (error) return <p>Error: {error}</p>; // Removed blocking error for new user creation flow

  return (
    <Router>
      <AppContent userData={userData} user={user} />
    </Router>
  );
}

export default App;
